'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollNavigationContentToTop = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _NavigationApp = require('./NavigationApp.scss');

var _NavigationApp2 = _interopRequireDefault(_NavigationApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAVIGATION_APP_CONTENT_ID = 'navigation_app_content_id';

var scrollNavigationContentToTop = exports.scrollNavigationContentToTop = function scrollNavigationContentToTop() {
  window.document.getElementById(NAVIGATION_APP_CONTENT_ID).scrollTop = 0;
};

var NavigationApp = function (_React$Component) {
  (0, _inherits3.default)(NavigationApp, _React$Component);

  function NavigationApp(props) {
    (0, _classCallCheck3.default)(this, NavigationApp);

    // https://stackoverflow.com/questions/45373742/detect-route-change-with-react-router?rq=1
    var _this = (0, _possibleConstructorReturn3.default)(this, (NavigationApp.__proto__ || (0, _getPrototypeOf2.default)(NavigationApp)).call(this, props));

    _this.unlisten = _this.props.history.listen(function (location) {
      _this.props.onNavigationChange(location);
    });
    return _this;
  }

  (0, _createClass3.default)(NavigationApp, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.onWillMount();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _NavigationApp2.default.wrap },
        this.props.menu,
        _react2.default.createElement(
          'div',
          { id: NAVIGATION_APP_CONTENT_ID, className: _NavigationApp2.default.content },
          _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            this.props.routes.map(function (route) {
              return _react2.default.createElement(_reactRouterDom.Route, {
                key: route.id,
                path: route.path,
                exact: route.exact,
                render: route.component
              });
            }),
            this.props.noMatch ? _react2.default.createElement(_reactRouterDom.Route, { component: this.props.noMatch }) : null
          )
        )
      );
    }
  }]);
  return NavigationApp;
}(_react2.default.Component);

NavigationApp.propTypes = {
  hashRouter: _propTypes2.default.bool,
  routes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  noMatch: _propTypes2.default.func,
  menu: _propTypes2.default.element.isRequired,
  onNavigationChange: _propTypes2.default.func.isRequired
};

exports.default = NavigationApp;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/navigation/NavigationApp.js
// module id = 338
// module chunks = 10